import { clientApiScope, Constants } from "../../../services/web/api.const";
import { useApi, useApiAsync } from "../../../services/web/use-api";
import { CityConfig, CityConfigUpdatePayload } from "../payment-zone-area.type";

export const useGetCityConfig = (cityId: string) => {
  const url = `${Constants.CLIENTS_API_URL}/cities/${cityId}`;
  const options = {
    ...clientApiScope,
    method: "GET",
    headers: { "Content-type": "application/json; charset=UTF-8", "api-version": "v2" },
  };

  const { isLoading, data, error } = useApi<CityConfig>(url, options, ["city-config", cityId], !!cityId, {
    placeholderData: {} as CityConfig,
    retry: false,
  });
  return { isLoading, data, error };
};

export const useUpdateCityConfig = (cityId: string) => {
  const url = `${Constants.CLIENTS_API_URL}/cities/${cityId}`;
  const options = {
    ...clientApiScope,
    method: "PUT",
    headers: { "Content-type": "application/json; charset=UTF-8", "api-version": "v2" },
  };

  const {
    mutateAsync: updateCityConfig,
    isPending: isLoading,
    error,
  } = useApiAsync<CityConfig, CityConfigUpdatePayload>(url, options, ["city-config", cityId]);

  return { updateCityConfig, isLoading, error };
};
